const JoiningSuccessPage = () =>{
    return (
        <>
       <main className="user_maincontainer">
			<div className="container-fluid">
				<div className="row">
					<div className="col-md-12 text-center">
						<div className="thankyou_wrp">
							<i className="icon icon-check"></i>
							<h1>Thank you !</h1>
							<p>Your onboarding form is successfully submitted.</p>
						</div>
					</div>
					
				
				</div>
			</div>
		
	</main>
        </>
    )
}
export default JoiningSuccessPage;